import { Card } from '@paygreen/paygreen-ui';
import styled from 'styled-components';

const CardStyled = styled(Card)`
    min-height: 600px;
    height: 100%;
`;

export default CardStyled;
